import * as React from 'react';

import type { W_MaterialCost_FindForWorkSummary_VM_Single } from 'ab-api/web/materialCost/findForWorkSummary';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import { dollarFormatter, numberFormatter } from 'af-utils/format.util';

const formatter = numberFormatter(2, 0);

interface OwnProps {
	convertedBaseCost: Nullable<number>;
	materialCost: W_MaterialCost_FindForWorkSummary_VM_Single;
	onDate: string;
}

type Props = OwnProps;

const TotalCostBreakdown: React.FC<Props> = (props) => {
	const { materialCost, onDate, convertedBaseCost } = props;

	const { baseCost, shippingMarkup, salesMarkup, tax } = materialCost;

	const shippingFormatted = formatter.format(shippingMarkup);
	const salesFormatted = formatter.format(salesMarkup);
	const taxFormatted = formatter.format(tax);

	const dateFormatted = React.useMemo(() => {
		return TimeUtils.formatDate(onDate, TimeFormat.DATE_ONLY, TimeFormat.DB_DATE_ONLY);
	}, [onDate]);

	return (
		<div>
			<div><b>Total Cost on {dateFormatted}</b></div>
			<div>
				<b>Base Cost</b> ({dollarFormatter.format(convertedBaseCost ?? baseCost)})
				× <b>Tax</b> ({taxFormatted}%)
				× <b>Shipping</b> ({shippingFormatted}%)
				× <b>Sales</b> ({salesFormatted}%)
			</div>
		</div>
	);
};

export default React.memo(TotalCostBreakdown);
